<template>
  <v-form class="buyerdetails" ref="buyerDetailsForm" v-model="valid" lazy-validation>
    <div class="text-xs-left subheading font-weight-bold ">Buyer Information</div>
    <div class="ma-4">
      <v-text-field
        label="name"
        color="accent"
        v-model="buyerName"
        :rules="nameRules"
        @change="nameChanged"
        placeholder="your name"></v-text-field>

      <v-tooltip bottom>
        <v-text-field
          color="accent"
          slot="activator"
          label="phone number"
          v-model="buyerPhone"
          mask="phone"
          @change="phoneChanged"
          :rules="phoneRules"
          :append-icon="$vuetify.icons.help"
          placeholder="phone number with area code"></v-text-field>
          <span>If there is a problem with your order we may call you.</span>
      </v-tooltip>

      <v-flex>
        <v-tooltip bottom>
          <v-text-field
            color="accent"
            label="email"
            v-on:change="emailChanged"
            v-model=emailValue
            placeholder="your email"
            slot="activator"
            :rules="emailRules"
            :append-icon="$vuetify.icons.help">
          </v-text-field>
          <span>A valid email account is required to send order information and updates to you.</span>
        </v-tooltip>
      </v-flex>
    </div>
</v-form>

</template>

<script>
import {mapState} from 'vuex'
import utils from '../../../utils.ts'

export default {
  name: 'buyerdetails',
  components: {
  },
  data: function () {
    return {
      valid: false,
      nameRules: [
        utils.required('Name is required'),
      ],
      emailRules: [
        utils.required('This field is required'),
        utils.emailValidation('Email is not valid')
      ],
      phoneRules: [
        utils.required('Phone is required'),
        utils.phoneValidation('Invalid phone number.')
        // validPhone // Check for phone type?
      ]
    }
  },
  computed: {
    ...mapState({
      name: state => state.buyerInfo.name,
      phone: state => state.buyerInfo.phone,
      email: state => state.buyerInfo.email
    }),
    buyerName: {
      set (newName) {
        // Do nothing (?)
        this.nameChanged(newName)
      },
      get () {
        return this.name
      }
    },
    buyerPhone: {
      set (newPhone) {
        // Do nothing (?)
        this.phoneChanged(newPhone)
      },
      get () {
        return this.phone
      }
    },
    emailValue: {
      set (newValue) {
        // Do nothing (?)
        this.emailChanged(newValue)
      },
      get () {
        return this.email
      }
    },
  },
  mounted: function () {
    // Now load the categories
    this.$store.dispatch('buyerInfo/loadBuyer')
  },
  methods: {

    validPhone: function (v) {
      return true
    },
    nameChanged: function (val) {
      // Store it in the DB "buyers" table
      this.$store.dispatch('buyerInfo/storeName', val)
    },
    emailChanged: function (val) {
      console.log('EMAIL CHANGED')
      // Store it in the DB "buyers" table
      this.$store.dispatch('buyerInfo/storeEmail', val)
    },
    phoneChanged: function (val) {
      // Store it in the DB "buyers" table
      this.$store.dispatch('buyerInfo/storePhone', val)
    },
    getData: function () {
      // Returns the form data
      return {
        name: this.name,
        phone: this.phone,
        email: this.email
      }
    },
    isValid: function () {
      return this.$refs.buyerDetailsForm.validate()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

v-text-field {
  color: white;
}
</style>
